import {
    Component,
    Input,
} from '@angular/core';

@Component({
    selector: 'seed-start',
    templateUrl: './seed-start.component.html',
    styles: [`
        .wizard-heading {
            font-weight: bold;
        }
    `]
})
export class SeedStartComponent {
    @Input() workgroupName = '';
}
